(() => {
  const widths = [320, 480, 600, 750, 900, 1100, 1300, 1600];
  const imageUrl = (src, width) => {
    const url = new URL(src, window.location.origin);
    url.searchParams.set('width', width);
    return url.href;
  };
  window.audioExchangeProductImages = {
    updateGallery(element, image) {
      if (!element || !image?.src) return;
      const maxWidth = Math.min(image.width || 1600, 1600);
      const candidates = widths.filter(width => width < maxWidth).concat(maxWidth);
      element.srcset = candidates.map(width => `${imageUrl(image.src, width)} ${width}w`).join(', ');
      element.src = imageUrl(image.src, Math.min(maxWidth, 900));
      element.alt = image.alt || '';
      if (image.width && image.height) {
        element.width = image.width;
        element.height = image.height;
      }
    },
    updateSticky(root, image) {
      if (!root || !image?.src) return;
      const source = root.querySelector('.sticky-image source');
      const element = root.querySelector('.sticky-image img');
      if (source) source.srcset = `${imageUrl(image.src, 90)} 90w, ${imageUrl(image.src, 180)} 180w`;
      if (element) element.alt = image.alt || '';
    }
  };
})();
